












































import { Component, Prop, Vue } from "vue-property-decorator";
import StripeApi from "@/services/StripeApi";
import TooltipModule from "@/store/tooltip";
import CTooltip from "@/components/CTooltip.vue";
import { UpdateSubscription } from "@/api/lab-base-api-client";
import logger from "@/lib/log/logger";

@Component({
  components: {
    CTooltip,
  },
})
export default class CouponForm extends Vue {
  // 入力フォーム初期値
  private form: UpdateSubscription = { subId: "", promoCode: "" };

  // エラーモーダル表示
  private get isTooltipShow() {
    return TooltipModule.isShow;
  }

  @Prop({ type: String, required: true })
  cusId: string | undefined;

  // 「送信」clickで実行
  private async submit() {
    try {
      if (this.cusId) {
        // subIdの取得
        const subscriptionRes = await StripeApi.instance.getSubscriptionByCusId(this.cusId);

        const subscription = subscriptionRes.data.data;

        this.form.subId = subscription[0].id;
        // クーポンの適用
        await StripeApi.instance.updateSubscription(this.form);
        this.$router.push({ name: "URegisterPayment" });
      }
    } catch (err) {
      TooltipModule.commitIsShow(true);
      setTimeout(() => {
        TooltipModule.commitIsShow(false);
      }, 5000);
      if (err instanceof Error) {
        logger.frontError(`${err.name}: ${err.message}`);
        console.log(err);
      }
    }
  }
}
